import React from 'react'
import PropTypes from 'prop-types'
import ArrowLinks from '../arrowLinks'
import sanitizedContentData from '@/components/shared/utils/sanitizedContentData'
import './styles.scoped.scss'
import SvgNotAvailableImage from './svgNotAvailableImage'

const CardNews = ({
  imageSrc,
  title,
  description,
  link,
  target,
  firstslidehidde,
  kind_of_news,
  dataIndex,
}) => {
  const cardContent = (
    <div className="h-full w-auto">
      <a href={link} target={target} rel="noopener noreferrer" className="wrapper">
        <div className="card-news__image">
          {imageSrc ? <img src={imageSrc} alt={title} /> : <SvgNotAvailableImage />}
        </div>
        <div className="card-news__content">
          <>
            <h3
              className="card-news__title"
              dangerouslySetInnerHTML={sanitizedContentData(title)}
            />
            <div
              className="card-news__description"
              dangerouslySetInnerHTML={sanitizedContentData(description)}
            />
          </>
          {kind_of_news !== 'Blog' && <ArrowLinks target={target} href={link} textLink="" />}
        </div>
      </a>
    </div>
  )

  return (
    <div data-index={dataIndex} className={`card-news ${firstslidehidde ? 'last-slide' : ''}`}>
      {cardContent}
    </div>
  )
}

CardNews.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  target: PropTypes.string,
  firstslidehidde: PropTypes.bool,
  kind_of_news: PropTypes.string,
  dataIndex: PropTypes.number,
}

CardNews.default = {
  imageSrc: 'https://via.placeholder.com/404x310',
  title: 'Custom image title',
  description:
    'Our bride, Justine, reminisces over the unforgettable moment when she walked down the aisle and the fireworks that signaled the perfect ending to a magical night.',
  link: '#',
  target: '_blank',
  classNames: false,
  kind_of_news: 'Blog',
  dataIndex: 0,
}

export default CardNews
